import React from 'react';

export default function BackIcon() {
  return (
    <svg width="17" height="12" viewBox="0 0 17 12" xmlns="http://www.w3.org/2000/svg">
      <path
        fill="currentColor"
        d="M5.95 11.9L7.1485 10.7015L3.2555 6.8H17V5.1H3.2555L7.157 1.1985L5.95 0L0 5.95L5.95 11.9Z"
      />
    </svg>
  );
}
